import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
    theme: {
        tokens: {
            colors: {
                primary: { value: "#556ee6" },
                text: { value: "#131d4f" },
                grey: { 50: "#f7f7fa" },
                tableHeader: { value: "#d4dbfa" },
                brand: {
                    50: { value: "#fbe9e5" },
                    100: { value: "#f5d1ca" },
                    200: { value: "#eda893" },
                    300: { value: "#e6805d" },
                    400: { value: "#df5733" },
                    500: { value: "##131d4f" },  // **Base color**  
                    600: { value: "#bb5227" },
                    700: { value: "#9b4221" },
                    800: { value: "#7b331b" },
                    900: { value: "#5a2414" },
                    950: { value: "#3a150c" }
                }
            },
        },
        semanticTokens: {
            colors: {
                brand: {
                    solid: { value: "{colors.brand.500}" },      // Base brand color (D6622D)
                    contrast: { value: "{colors.brand.100}" },  // White contrast
                    fg: { value: "{colors.brand.700}" },        // Foreground color
                    muted: { value: "{colors.brand.100}" },     // Muted gray
                    subtle: { value: "{colors.brand.200}" },    // Light gray
                    emphasized: { value: "{colors.brand.300}" }, // Slightly darker gray
                    focusRing: { value: "{colors.brand.500}" }, // Highlight color
                },
            },
        },
    },
    globalCss: {
        html: {
            backgroundColor: "grey.50",
            fontFamily: `'DM Sans', sans-serif`,
        },
        body: {
            fontFamily: `'DM Sans', sans-serif`,
        }
    },
})

export const system = createSystem(defaultConfig, config);

